import ReviewSummaryReportFooter from './ReviewSummaryReportFooter';

export default ReviewSummaryReportFooter;
